import $ from 'jquery'
import { selectors } from '../selectors'

export default function () {
    $(selectors.sliders.sliderBlog).each(function () {
        const slider = $(this)
        const slidesToShow = parseInt(slider.attr('data-slides-to-show')) || 3
        const slidesToScroll = parseInt(slider.attr('data-slides-to-scroll')) || 2

        const prevArrow = slider.closest(selectors.sliders.tabsContent).find(selectors.sliders.arrowPrev)
        const nextArrow = slider.closest(selectors.sliders.tabsContent).find(selectors.sliders.arrowNext)

        slider.slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            prevArrow: $(prevArrow),
            nextArrow: $(nextArrow),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })
    })
}
